import { Box, Flex } from "@backstage/ui";
import { type Message } from "@internal/plugin-askjack-common";

import { ChatMessage } from "./ChatMessage";
import chatMessageStyles from "./ChatMessage.module.css";
import { EmptyState } from "./EmptyState";
import styles from "./MessageList.module.css";

export interface MessageListProps {
    messages: Message[];
    endRef: React.RefObject<HTMLDivElement>;
    centerEmptyState: boolean;
    loading?: boolean;
}

const TypingDots = () => (
    <Box mb="1" className={chatMessageStyles.messageLeft}>
        <Box
            as="div"
            className={`${chatMessageStyles.bubble} ${chatMessageStyles.bubbleBot}`}
        >
            <Flex
                gap="1"
                align="center"
                className={chatMessageStyles.typingDots}
            >
                {[0, 1, 2].map(i => (
                    <div
                        key={i}
                        className={`${chatMessageStyles.dot} ${
                            chatMessageStyles[
                                `dot${i}` as keyof typeof chatMessageStyles
                            ]
                        }`}
                    />
                ))}
            </Flex>
        </Box>
    </Box>
);

export const MessageList = ({
    messages,
    endRef,
    centerEmptyState,
    loading = false,
}: MessageListProps) => (
    <Box className={styles.list}>
        {messages.length === 0 && !loading ? (
            <EmptyState centered={centerEmptyState} />
        ) : (
            messages.map(msg => <ChatMessage key={msg.id} msg={msg} />)
        )}
        {loading && <TypingDots />}
        <div ref={endRef} />
    </Box>
);
